import styled from "styled-components";

export const BotChatStreamingMessageCloudLoadingAnimation = styled.span`
  ${(props) => props?.theme?.themeConfig?.chatMessages?.botMessage?.loadingAnimation?.styles};

  &::before {
    ${(props) =>
      props?.theme?.themeConfig?.chatMessages?.botMessage?.loadingAnimation?.before?.styles};
  }

  &::after {
    ${(props) =>
      props?.theme?.themeConfig?.chatMessages?.botMessage?.loadingAnimation?.after?.styles};
  }
`;